import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const c = o((e, i) => /* @__PURE__ */ l.jsx(
  s,
  {
    ref: i,
    ...e,
    image: (r) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: [
          /* @__PURE__ */ l.jsx("g", { clipPath: "url(#clip0_3410_69069)", children: /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m-.293-5.293 4.5-4.5-1.414-1.414L7 8.586 5.207 6.793 3.793 8.207l2.5 2.5a1 1 0 0 0 1.414 0",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_3410_69069", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
c.displayName = "CircleCheckIcon";
export {
  c as CircleCheckIcon,
  c as default
};
//# sourceMappingURL=index.js.map
